export const SEO_CONFIG = {
  home: {
    title: 'KAMS LED - Professional Commercial Lighting Manufacturer Since 2009',
    description: 'High-quality commercial LED lighting manufacturer with global projects experience since 2009.',
    keywords: 'lighting,LED lighting,commercial lighting,KAMS LED,downlights,spotlights',
    image: '/images/og-image.jpg'
  },
  products: {
    title: 'Products - KAMS LED Lighting Solutions',
    description: 'Explore our premium LED lighting products including downlights, track lights and strip lights.',
    keywords: 'LED products,downlights,track lights,strip lights',
    image: '/images/products/og-image.jpg'
  },
  // 其他页面配置...
};

export const generateStructuredData = (pageType, data = {}) => {
  const baseData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": data.title || '',
    "description": data.description || '',
    "url": data.url || ''
  };

  // 根据不同页面类型添加特定结构化数据
  switch(pageType) {
    case 'product':
      return {
        ...baseData,
        "@type": "Product",
        "image": data.image || '',
        "brand": {
          "@type": "Brand",
          "name": "KAMS LED"
        },
        // 其他产品特有字段...
      };
    // 其他case...
    default:
      return baseData;
  }
};